import loading from 'assets/loading.svg';
import Grid from '@mui/material/Grid';
import {Box} from '@mui/material';

export const Loading = ({isFullHeight = true}) => {
  const styles = isFullHeight ? {height: '100vh'} : {};
  return (
    <Grid container justifyContent="center" alignItems="center" style={styles}>
      <img src={loading} alt="Loading" />
    </Grid>
  );
};

export const LoadingOverlay = () => {
  return (
    <Box height={100} width={100} position="absolute" zIndex={5000} left="calc(50% - 60px)" top="calc(50% - 60px)">
      <img src={loading} alt="Loading" />
    </Box>
  );
};
